/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_Y_Padding_Range_ErrorInputs */

const en_iframe_remote_y_padding_range_error = /** @type {(inputs: Iframe_Remote_Y_Padding_Range_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vertical padding must be between 0 and 50`)
};

const fr_iframe_remote_y_padding_range_error = /** @type {(inputs: Iframe_Remote_Y_Padding_Range_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le padding vertical doit etre entre 0 et 50`)
};

const de_iframe_remote_y_padding_range_error = /** @type {(inputs: Iframe_Remote_Y_Padding_Range_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der vertikale Abstand muss zwischen 0 und 50 liegen.`)
};

const it_iframe_remote_y_padding_range_error = /** @type {(inputs: Iframe_Remote_Y_Padding_Range_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La spaziatura verticale deve essere compresa tra 0 e 50`)
};

const ru_iframe_remote_y_padding_range_error = /** @type {(inputs: Iframe_Remote_Y_Padding_Range_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вертикальный отступ должен быть в диапазоне от 0 до 50.`)
};

const es_iframe_remote_y_padding_range_error = /** @type {(inputs: Iframe_Remote_Y_Padding_Range_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El relleno vertical debe estar entre 0 y 50`)
};

const zh_cn2_iframe_remote_y_padding_range_error = /** @type {(inputs: Iframe_Remote_Y_Padding_Range_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`垂直边距必须介于 0 和 50 之间。`)
};

const ja_iframe_remote_y_padding_range_error = /** @type {(inputs: Iframe_Remote_Y_Padding_Range_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`垂直パディングは0から50の間でなければなりません`)
};

const hi_iframe_remote_y_padding_range_error = /** @type {(inputs: Iframe_Remote_Y_Padding_Range_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वर्टिकल पैडिंग 0 और 50 के बीच होनी चाहिए।`)
};

const pt_pt2_iframe_remote_y_padding_range_error = /** @type {(inputs: Iframe_Remote_Y_Padding_Range_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O espaçamento vertical deve estar entre 0 e 50.`)
};

/**
* | output |
* | --- |
* | "Vertical padding must be between 0 and 50" |
*
* @param {Iframe_Remote_Y_Padding_Range_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_y_padding_range_error = /** @type {((inputs?: Iframe_Remote_Y_Padding_Range_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Y_Padding_Range_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iframe_remote_y_padding_range_error(inputs)
	if (locale === "de") return de_iframe_remote_y_padding_range_error(inputs)
	if (locale === "it") return it_iframe_remote_y_padding_range_error(inputs)
	if (locale === "ru") return ru_iframe_remote_y_padding_range_error(inputs)
	if (locale === "es") return es_iframe_remote_y_padding_range_error(inputs)
	if (locale === "zh-CN") return zh_cn2_iframe_remote_y_padding_range_error(inputs)
	if (locale === "ja") return ja_iframe_remote_y_padding_range_error(inputs)
	if (locale === "hi") return hi_iframe_remote_y_padding_range_error(inputs)
	if (locale === "pt-PT") return pt_pt2_iframe_remote_y_padding_range_error(inputs)
	return en_iframe_remote_y_padding_range_error(inputs)
});